import React, { useEffect, useMemo, useRef, useState } from "react";
import { MapContainer, TileLayer, GeoJSON, Circle, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { useSelector } from "react-redux";

const Map = () => {
  const { revenuData, revenueDataLoaded } = useSelector(
    (state) => state.revenue
  );
  const { getReviewData } = useSelector((state) => state.reviews);

  const [features, setFeatures] = useState([]);
  const mapref = useRef();

  useEffect(() => {
    if (
      getReviewData &&
      getReviewData != undefined &&
      getReviewData.GeoTable != undefined &&
      getReviewData
    ) {
      if (getReviewData?.GeoTable && getReviewData?.GeoTable?.length > 0) {
        setFeatures([]);
        getReviewData?.GeoTable.forEach((zipcode) => {
          if (zipcode.lat != null && zipcode.long != null) {
            zipcodeToCoordinates(
              zipcode.Pincode,
              zipcode.Location,
              zipcode.lat,
              zipcode.long,
              zipcode.Count
            );
          }
        });
      }
      else{
         zipcodeToCoordinates(
            "",
            "",
            "",
            "",
            ""
          );
      }
    }
  }, [getReviewData]);

  async function zipcodeToCoordinates(
    zipCode,
    name,
    lat,
    long,
    newContrct,
    existontract,
    upsell,
    Rdd
  ) {
    try {
      let displayname = name;
      let coordinates = { latitude: lat, longitude: long };
      let reversedCoordinates = [coordinates.longitude, coordinates.latitude];
      let id = Math.random();
      let newContract = newContrct;
      let existingcontract = existontract;
      let upselling = upsell;
      let rdd = Rdd;
      setFeatures((prevFeatures) => [
        ...prevFeatures,
        createFeature(
          displayname,
          reversedCoordinates,
          id,
          newContract,
          existingcontract,
          upselling,
          rdd
        ),
      ]);
    } catch (error) {
      console.log("An error occurred while fetching coordinates.");
    }
  }

  function createFeature(
    name,
    coordinates,
    id,
    NewContract,
    ExistingContract,
    Upselling,
    rdd
  ) {
    return {
      type: "Feature",
      id: id.toString(),
      properties: {
        name: name,
        NewContract: NewContract,
        ExistingContract: ExistingContract,
        Upselling: Upselling,
        rdd: rdd,
      },
      geometry: {
        type: "Point",
        coordinates: coordinates,
      },
    };
  }

  const USData = useMemo(
    () => ({
      type: "FeatureCollection",
      features: features,
    }),
    [features]
  );

  return (
    <>
      <div className="card">
        <div className="card-body">
          <div id="map">
            <MapContainer
              key={Math.random()}
              style={{ height: "500px", width: "100%" }}
              center={[35.7596, -79.0193]}
              zoom={8.5}
              ref={mapref}
            >
              {USData &&
                USData?.features.map((feature) => (
                  <Circle
                    key={Math.random()}
                    center={feature?.geometry?.coordinates.reverse()}
                    radius={feature.properties.NewContract > 80 ? 3000 : 3000}
                    pathOptions={{
                      color: "#fc6075",
                      fillColor: "#fc6075",
                      fillOpacity: 0.4,
                    }}
                  >
                    <Popup>
                      <h4>{feature.properties.name}</h4>

                      {feature.properties.NewContract != undefined && (
                        <div>
                          <span style={{ marginRight: "5px" }}></span>
                          Count:<b>{feature.properties.NewContract}</b>
                        </div>
                      )}
                    </Popup>
                  </Circle>
                ))}

              <TileLayer url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png" />
              <GeoJSON data={USData} key={Math.random()} />
            </MapContainer>
          </div>
        </div>
      </div>
    </>
  );
};

export default Map;
